import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loading } from "@/layouts/components/Loading";
import { RoutesList } from "@/router/routesList";
import { useDeleteUserMutation, useGetUserByIdQuery } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { convertToViewModel } from "../common/mappers";
import { UserDetails } from "./components/UserDetails";
export var UserDetailsPage = function () {
    var userId = useParams().userId;
    var userGetState = useGetUserByIdQuery({
        id: userId,
    });
    var navigate = useNavigate();
    var editClickHandler = function () {
        navigate(RoutesList.Users.getUserEdit(userGetState.data.id));
    };
    var _a = useDeleteUserMutation(), userDeleteAction = _a[0], userDeleteState = _a[1];
    var deleteClickHandler = function () {
        userDeleteAction({ id: userId });
    };
    useEffect(function () {
        if (userDeleteState.isSuccess) {
            navigate(RoutesList.Users.getUsersList());
        }
    }, [userDeleteState.isSuccess]);
    useSetPageData({ title: "Пользователь" });
    var isLoading = userGetState.isLoading || userDeleteState.isLoading;
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: isLoading, loadingKey: "userDetails" }), userGetState.isSuccess && (_jsx(UserDetails, { data: convertToViewModel(userGetState.data), onEditClick: userGetState.data.meta.canEdit ? editClickHandler : undefined, onDeleteClick: userGetState.data.meta.canEdit ? deleteClickHandler : undefined }))] }));
};
